import { useInfiniteTableItems } from "@/app/components/infinite-table/use-infinite-table-items"
import { NftFiltersMoleculeReatom } from "@/app/nft/search/filters/store.reatom"
import { NftSearchResultMoleculeReatom } from "@/app/nft/search/result/store.reatom"
import {
  clearExpiredListing,
  sortNotListedLast,
} from "@/app/nft/search/result/utils"
import { NftSortMoleculeReatom } from "@/app/nft/search/sort/store.reatom"
import { useSuspenseInfiniteQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { useMemo } from "react"

export const useTableItems = () => {
  const { nftSearchQueryParamsAtom } = useMolecule(
    NftSearchResultMoleculeReatom,
  )
  const { sortAtom } = useMolecule(NftSortMoleculeReatom)
  const { statusFilter } = useMolecule(NftFiltersMoleculeReatom)
  const queryParams = nftSearchQueryParamsAtom()
  const sort = sortAtom()
  const status = statusFilter()
  const query = useSuspenseInfiniteQuery(queryParams)
  const queryResult = useMemo(
    () => ({
      ...query,
      pages: [
        {
          items: sortNotListedLast(
            query.data.pages.flatMap((page) =>
              page.nfts.map(clearExpiredListing),
            ),
            sort,
            status,
          ),
        },
      ],
    }),
    [query, sort, status],
  )

  return useInfiniteTableItems(queryResult)
}
